import Booking from "./booking";
import {listener} from "../../../../../../modules/vegas/js/util";

listener('loaded', '#modal-booking', () => {
	Booking.init();
});

/**
 * Переключаемся, вперед, назад
 */
listener('click', '[data-vg-toggle="booking"]', function (el, e) {
	e.preventDefault();
	Booking.toggle(el);
});

/**
 * Выбираем услугу
 */
listener('click', '[data-vg-toggle="choose-service"]', function (el, e) {
	e.preventDefault();
	Booking.Set.service(el);
});

/**
 * Выбираем дату и время
 */
listener('click', '[data-vg-toggle="choose-datetime"]', function (el, e) {
	e.preventDefault();
	Booking.Set.setDateTime(el);
});

/**
 * Отправляем данные на сервер
 */
listener('submit', '#form-booking', function (el, e) {
	e.preventDefault();
	Booking.submit(el);
})
